import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../../shared/base-classes/base.component';
import {
  EventCategoryFilterDto,
  EventCategoryListResponseDto
} from '@whetstoneeducation/hero-common';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { AppEventService } from '../events.service';
import { AppPageHeaderService } from '../../../shared/page-header/page-header.service';
import { AppConfirmationDialogService } from '../../../shared/confirmation-dialog/confirmation-dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { HeaderButtonAction } from '../../../shared/page-header/header-button';
import { EventCategoryCreateEditModalComponent } from './event-cateogry-create-edit-modal/event-category-create-edit-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ITableFilters } from '../../../shared/tables/table-filters/table-filters.interface';
import { AppConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-event-category-list',
  templateUrl: './event-category-list.component.html',
  styleUrls: ['./event-category-list.component.scss']
})
export class AppEventCategoryListComponent
  extends BaseComponent
  implements OnDestroy
{
  public eventCategories: EventCategoryListResponseDto[] = [];
  public filters: EventCategoryFilterDto = new EventCategoryFilterDto();
  public destroy$ = new Subject<void>();

  constructor(
    public toastService: AppToastManagerService,
    public eventsService: AppEventService,
    public pageHeaderService: AppPageHeaderService,
    public confirmationDialog: AppConfirmationDialogService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router
  ) {
    super();
    this.loadData();

    this.pageHeaderService.buttonAction$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (action: string) => {
        if (action === HeaderButtonAction.CREATE) {
          this.showCreateEditModal();
        }
        if (action === HeaderButtonAction.BACK) {
          await this.router.navigate(['/events']);
        }
      });
  }

  public loadData() {
    this.eventCategories = this.route.snapshot.data.data.eventCategories;
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public async reloadData() {
    this.isLoading = true;
    this.eventCategories = await this.eventsService.getEventCategories(
      this.filters
    );
    this.isLoading = false;
  }

  public showCreateEditModal(id?: number): void {
    this.dialog.open(EventCategoryCreateEditModalComponent, {
      width: '600px',
      height: '250px',
      panelClass: 'default-dialog',
      data: {
        id
      }
    });

    this.dialog.afterAllClosed.subscribe(async () => {
      await this.reloadData();
    });
  }

  public get getTableFilters(): ITableFilters {
    return {
      count: this.eventCategories.length,
      page: this.filters.page,
      itemsPerPage: this.filters.itemsPerPage,
      active: 'true',
      direction: 'asc'
    };
  }

  public async updateTableFilters(newTableFilters: ITableFilters) {
    this.isLoading = true;
    this.filters = new EventCategoryFilterDto({
      ...this.filters,
      ...newTableFilters
    });
    await this.reloadData();
    this.isLoading = false;
  }

  public showDeleteModal(id: number): void {
    this.dialog.open(AppConfirmationDialogComponent, {
      data: {
        title: 'Are you sure you want to delete this event category?',
        content:
          'Deleting this import will permanently remove it. This action cannot be undone.',
        actions: [
          {
            key: 'cancel',
            label: 'Cancel',
            color: 'primary',
            classes: 'modal-delete-button'
          },
          {
            key: 'delete',
            label: 'Yes, I am sure',
            color: 'primary',
            classes: 'modal-submit-button',
            awaitAction: true,
            action: async () => {
              await this.eventsService.deleteEventCategory(id);
              await this.reloadData();
              this.dialog.closeAll();
            }
          }
        ]
      }
    });
  }
}
